import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { AppState } from 'src/app';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public authorizationSession: string = undefined;
  public idTokenSession: string = undefined;

  constructor(private store: Store<AppState>) {
    this.store
      .select('elPatron')
      .pipe(
        distinctUntilChanged(),
        map((value: any) => value.toJS()),
        filter((value: any) => !!value.refreshedToken),
      )
      .subscribe((value: any) => {
        this.setAuthorizationSession(value.refreshedToken);
      });
  }

  public setAuthorizationSession(validSession: string) {
    this.authorizationSession = validSession;
  }

  public getAuthorizationSession() {
    return this.authorizationSession;
  }

  public setIdTokenSession(idToken: string) {
    this.idTokenSession = idToken;
  }

  public getIdTokenSession(): string {
    return this.idTokenSession;
  }
}
